var Xe = Object.defineProperty;
var Ze = (n, e, t) => e in n ? Xe(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var Q = (n, e, t) => Ze(n, typeof e != "symbol" ? e + "" : e, t);
import { defineComponent as E, openBlock as y, createElementBlock as S, toDisplayString as ue, normalizeClass as T, renderSlot as I, createElementVNode as p, pushScopeId as et, popScopeId as tt, useCssVars as rt, ref as B, onUpdated as Le, h as V, onMounted as nt, computed as it, Fragment as Be, createVNode as st, createTextVNode as ot, useSlots as at, createCommentVNode as ne, unref as ct, reactive as Ce } from "vue";
import { defineStore as ut } from "pinia";
const lt = { id: "version-tag" }, ht = /* @__PURE__ */ E({
  __name: "VersionTag",
  props: {
    name: {},
    version: {}
  },
  setup(n) {
    return (e, t) => (y(), S("span", lt, ue(e.name) + ": " + ue(e.version), 1));
  }
}), G = (n, e) => {
  const t = n.__vccOpts || n;
  for (const [r, s] of e)
    t[r] = s;
  return t;
}, Yr = /* @__PURE__ */ G(ht, [["__scopeId", "data-v-bf1a7551"]]), Wr = /* @__PURE__ */ E({
  __name: "SidebarButton",
  props: {
    active: { type: Boolean }
  },
  emits: ["onClick"],
  setup(n) {
    return (e, t) => (y(), S("div", {
      class: T(["btn btn-revyoo", {
        "active bg-primary text-white": e.active
      }]),
      onClick: t[0] || (t[0] = (r) => e.$emit("onClick"))
    }, [
      I(e.$slots, "default")
    ], 2));
  }
}), ft = (n) => (et("data-v-29132f9e"), n = n(), tt(), n), dt = { class: "d-flex my-2" }, _t = { class: "col-2" }, pt = { class: "col-9 align-self-center" }, vt = { class: "col-1" }, mt = /* @__PURE__ */ ft(() => /* @__PURE__ */ p("i", { class: "fa fa-circle" }, null, -1)), gt = [
  mt
], bt = /* @__PURE__ */ E({
  __name: "WidgetHeader",
  emits: ["clicked:close"],
  setup(n) {
    return (e, t) => (y(), S("div", dt, [
      p("div", _t, [
        I(e.$slots, "start", {}, void 0, !0)
      ]),
      p("div", pt, [
        I(e.$slots, "center", {}, void 0, !0)
      ]),
      p("div", vt, [
        p("div", {
          class: "btn btn-default btn-revyoo-close",
          onClick: t[0] || (t[0] = (r) => e.$emit("clicked:close"))
        }, gt)
      ])
    ]));
  }
}), Gr = /* @__PURE__ */ G(bt, [["__scopeId", "data-v-29132f9e"]]), wt = { class: "widgetsWrapper" }, yt = { class: "rounded bg-revyoo btn-border h-100 w-100 d-flex flex-column" }, St = /* @__PURE__ */ E({
  __name: "WidgetWrapper",
  props: {
    width: { default: "420px" },
    height: { default: "60vh" },
    minHeight: { default: "30rem" }
  },
  setup(n) {
    return rt((e) => ({
      "683b6b59": e.width,
      f539f418: e.height,
      "92904ba8": e.minHeight
    })), (e, t) => (y(), S("div", wt, [
      p("div", yt, [
        I(e.$slots, "default", {}, void 0, !0)
      ])
    ]));
  }
}), Jr = /* @__PURE__ */ G(St, [["__scopeId", "data-v-e2711f83"]]);
/*!
 * qrcode.vue v3.4.1
 * A Vue.js component to generate QRCode.
 * © 2017-2023 @scopewu(https://github.com/scopewu)
 * MIT License.
 */
var ee = function() {
  return ee = Object.assign || function(e) {
    for (var t, r = 1, s = arguments.length; r < s; r++) {
      t = arguments[r];
      for (var u in t) Object.prototype.hasOwnProperty.call(t, u) && (e[u] = t[u]);
    }
    return e;
  }, ee.apply(this, arguments);
};
var M;
(function(n) {
  var e = (
    /** @class */
    function() {
      function a(i, o, c, l) {
        if (this.version = i, this.errorCorrectionLevel = o, this.modules = [], this.isFunction = [], i < a.MIN_VERSION || i > a.MAX_VERSION)
          throw new RangeError("Version value out of range");
        if (l < -1 || l > 7)
          throw new RangeError("Mask value out of range");
        this.size = i * 4 + 17;
        for (var f = [], h = 0; h < this.size; h++)
          f.push(!1);
        for (var h = 0; h < this.size; h++)
          this.modules.push(f.slice()), this.isFunction.push(f.slice());
        this.drawFunctionPatterns();
        var d = this.addEccAndInterleave(c);
        if (this.drawCodewords(d), l == -1)
          for (var _ = 1e9, h = 0; h < 8; h++) {
            this.applyMask(h), this.drawFormatBits(h);
            var m = this.getPenaltyScore();
            m < _ && (l = h, _ = m), this.applyMask(h);
          }
        s(0 <= l && l <= 7), this.mask = l, this.applyMask(l), this.drawFormatBits(l), this.isFunction = [];
      }
      return a.encodeText = function(i, o) {
        var c = n.QrSegment.makeSegments(i);
        return a.encodeSegments(c, o);
      }, a.encodeBinary = function(i, o) {
        var c = n.QrSegment.makeBytes(i);
        return a.encodeSegments([c], o);
      }, a.encodeSegments = function(i, o, c, l, f, h) {
        if (c === void 0 && (c = 1), l === void 0 && (l = 40), f === void 0 && (f = -1), h === void 0 && (h = !0), !(a.MIN_VERSION <= c && c <= l && l <= a.MAX_VERSION) || f < -1 || f > 7)
          throw new RangeError("Invalid value");
        var d, _;
        for (d = c; ; d++) {
          var m = a.getNumDataCodewords(d, o) * 8, b = u.getTotalBits(i, d);
          if (b <= m) {
            _ = b;
            break;
          }
          if (d >= l)
            throw new RangeError("Data too long");
        }
        for (var v = 0, w = [a.Ecc.MEDIUM, a.Ecc.QUARTILE, a.Ecc.HIGH]; v < w.length; v++) {
          var C = w[v];
          h && _ <= a.getNumDataCodewords(d, C) * 8 && (o = C);
        }
        for (var g = [], R = 0, k = i; R < k.length; R++) {
          var P = k[R];
          t(P.mode.modeBits, 4, g), t(P.numChars, P.mode.numCharCountBits(d), g);
          for (var q = 0, J = P.getData(); q < J.length; q++) {
            var Je = J[q];
            g.push(Je);
          }
        }
        s(g.length == _);
        var re = a.getNumDataCodewords(d, o) * 8;
        s(g.length <= re), t(0, Math.min(4, re - g.length), g), t(0, (8 - g.length % 8) % 8, g), s(g.length % 8 == 0);
        for (var Se = 236; g.length < re; Se ^= 253)
          t(Se, 8, g);
        for (var K = []; K.length * 8 < g.length; )
          K.push(0);
        return g.forEach(function(Ke, Ee) {
          return K[Ee >>> 3] |= Ke << 7 - (Ee & 7);
        }), new a(d, o, K, f);
      }, a.prototype.getModule = function(i, o) {
        return 0 <= i && i < this.size && 0 <= o && o < this.size && this.modules[o][i];
      }, a.prototype.getModules = function() {
        return this.modules;
      }, a.prototype.drawFunctionPatterns = function() {
        for (var i = 0; i < this.size; i++)
          this.setFunctionModule(6, i, i % 2 == 0), this.setFunctionModule(i, 6, i % 2 == 0);
        this.drawFinderPattern(3, 3), this.drawFinderPattern(this.size - 4, 3), this.drawFinderPattern(3, this.size - 4);
        for (var o = this.getAlignmentPatternPositions(), c = o.length, i = 0; i < c; i++)
          for (var l = 0; l < c; l++)
            i == 0 && l == 0 || i == 0 && l == c - 1 || i == c - 1 && l == 0 || this.drawAlignmentPattern(o[i], o[l]);
        this.drawFormatBits(0), this.drawVersion();
      }, a.prototype.drawFormatBits = function(i) {
        for (var o = this.errorCorrectionLevel.formatBits << 3 | i, c = o, l = 0; l < 10; l++)
          c = c << 1 ^ (c >>> 9) * 1335;
        var f = (o << 10 | c) ^ 21522;
        s(f >>> 15 == 0);
        for (var l = 0; l <= 5; l++)
          this.setFunctionModule(8, l, r(f, l));
        this.setFunctionModule(8, 7, r(f, 6)), this.setFunctionModule(8, 8, r(f, 7)), this.setFunctionModule(7, 8, r(f, 8));
        for (var l = 9; l < 15; l++)
          this.setFunctionModule(14 - l, 8, r(f, l));
        for (var l = 0; l < 8; l++)
          this.setFunctionModule(this.size - 1 - l, 8, r(f, l));
        for (var l = 8; l < 15; l++)
          this.setFunctionModule(8, this.size - 15 + l, r(f, l));
        this.setFunctionModule(8, this.size - 8, !0);
      }, a.prototype.drawVersion = function() {
        if (!(this.version < 7)) {
          for (var i = this.version, o = 0; o < 12; o++)
            i = i << 1 ^ (i >>> 11) * 7973;
          var c = this.version << 12 | i;
          s(c >>> 18 == 0);
          for (var o = 0; o < 18; o++) {
            var l = r(c, o), f = this.size - 11 + o % 3, h = Math.floor(o / 3);
            this.setFunctionModule(f, h, l), this.setFunctionModule(h, f, l);
          }
        }
      }, a.prototype.drawFinderPattern = function(i, o) {
        for (var c = -4; c <= 4; c++)
          for (var l = -4; l <= 4; l++) {
            var f = Math.max(Math.abs(l), Math.abs(c)), h = i + l, d = o + c;
            0 <= h && h < this.size && 0 <= d && d < this.size && this.setFunctionModule(h, d, f != 2 && f != 4);
          }
      }, a.prototype.drawAlignmentPattern = function(i, o) {
        for (var c = -2; c <= 2; c++)
          for (var l = -2; l <= 2; l++)
            this.setFunctionModule(i + l, o + c, Math.max(Math.abs(l), Math.abs(c)) != 1);
      }, a.prototype.setFunctionModule = function(i, o, c) {
        this.modules[o][i] = c, this.isFunction[o][i] = !0;
      }, a.prototype.addEccAndInterleave = function(i) {
        var o = this.version, c = this.errorCorrectionLevel;
        if (i.length != a.getNumDataCodewords(o, c))
          throw new RangeError("Invalid argument");
        for (var l = a.NUM_ERROR_CORRECTION_BLOCKS[c.ordinal][o], f = a.ECC_CODEWORDS_PER_BLOCK[c.ordinal][o], h = Math.floor(a.getNumRawDataModules(o) / 8), d = l - h % l, _ = Math.floor(h / l), m = [], b = a.reedSolomonComputeDivisor(f), v = 0, w = 0; v < l; v++) {
          var C = i.slice(w, w + _ - f + (v < d ? 0 : 1));
          w += C.length;
          var g = a.reedSolomonComputeRemainder(C, b);
          v < d && C.push(0), m.push(C.concat(g));
        }
        for (var R = [], k = function(P) {
          m.forEach(function(q, J) {
            (P != _ - f || J >= d) && R.push(q[P]);
          });
        }, v = 0; v < m[0].length; v++)
          k(v);
        return s(R.length == h), R;
      }, a.prototype.drawCodewords = function(i) {
        if (i.length != Math.floor(a.getNumRawDataModules(this.version) / 8))
          throw new RangeError("Invalid argument");
        for (var o = 0, c = this.size - 1; c >= 1; c -= 2) {
          c == 6 && (c = 5);
          for (var l = 0; l < this.size; l++)
            for (var f = 0; f < 2; f++) {
              var h = c - f, d = (c + 1 & 2) == 0, _ = d ? this.size - 1 - l : l;
              !this.isFunction[_][h] && o < i.length * 8 && (this.modules[_][h] = r(i[o >>> 3], 7 - (o & 7)), o++);
            }
        }
        s(o == i.length * 8);
      }, a.prototype.applyMask = function(i) {
        if (i < 0 || i > 7)
          throw new RangeError("Mask value out of range");
        for (var o = 0; o < this.size; o++)
          for (var c = 0; c < this.size; c++) {
            var l = void 0;
            switch (i) {
              case 0:
                l = (c + o) % 2 == 0;
                break;
              case 1:
                l = o % 2 == 0;
                break;
              case 2:
                l = c % 3 == 0;
                break;
              case 3:
                l = (c + o) % 3 == 0;
                break;
              case 4:
                l = (Math.floor(c / 3) + Math.floor(o / 2)) % 2 == 0;
                break;
              case 5:
                l = c * o % 2 + c * o % 3 == 0;
                break;
              case 6:
                l = (c * o % 2 + c * o % 3) % 2 == 0;
                break;
              case 7:
                l = ((c + o) % 2 + c * o % 3) % 2 == 0;
                break;
              default:
                throw new Error("Unreachable");
            }
            !this.isFunction[o][c] && l && (this.modules[o][c] = !this.modules[o][c]);
          }
      }, a.prototype.getPenaltyScore = function() {
        for (var i = 0, o = 0; o < this.size; o++) {
          for (var c = !1, l = 0, f = [0, 0, 0, 0, 0, 0, 0], h = 0; h < this.size; h++)
            this.modules[o][h] == c ? (l++, l == 5 ? i += a.PENALTY_N1 : l > 5 && i++) : (this.finderPenaltyAddHistory(l, f), c || (i += this.finderPenaltyCountPatterns(f) * a.PENALTY_N3), c = this.modules[o][h], l = 1);
          i += this.finderPenaltyTerminateAndCount(c, l, f) * a.PENALTY_N3;
        }
        for (var h = 0; h < this.size; h++) {
          for (var c = !1, d = 0, f = [0, 0, 0, 0, 0, 0, 0], o = 0; o < this.size; o++)
            this.modules[o][h] == c ? (d++, d == 5 ? i += a.PENALTY_N1 : d > 5 && i++) : (this.finderPenaltyAddHistory(d, f), c || (i += this.finderPenaltyCountPatterns(f) * a.PENALTY_N3), c = this.modules[o][h], d = 1);
          i += this.finderPenaltyTerminateAndCount(c, d, f) * a.PENALTY_N3;
        }
        for (var o = 0; o < this.size - 1; o++)
          for (var h = 0; h < this.size - 1; h++) {
            var _ = this.modules[o][h];
            _ == this.modules[o][h + 1] && _ == this.modules[o + 1][h] && _ == this.modules[o + 1][h + 1] && (i += a.PENALTY_N2);
          }
        for (var m = 0, b = 0, v = this.modules; b < v.length; b++) {
          var w = v[b];
          m = w.reduce(function(R, k) {
            return R + (k ? 1 : 0);
          }, m);
        }
        var C = this.size * this.size, g = Math.ceil(Math.abs(m * 20 - C * 10) / C) - 1;
        return s(0 <= g && g <= 9), i += g * a.PENALTY_N4, s(0 <= i && i <= 2568888), i;
      }, a.prototype.getAlignmentPatternPositions = function() {
        if (this.version == 1)
          return [];
        for (var i = Math.floor(this.version / 7) + 2, o = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (i * 2 - 2)) * 2, c = [6], l = this.size - 7; c.length < i; l -= o)
          c.splice(1, 0, l);
        return c;
      }, a.getNumRawDataModules = function(i) {
        if (i < a.MIN_VERSION || i > a.MAX_VERSION)
          throw new RangeError("Version number out of range");
        var o = (16 * i + 128) * i + 64;
        if (i >= 2) {
          var c = Math.floor(i / 7) + 2;
          o -= (25 * c - 10) * c - 55, i >= 7 && (o -= 36);
        }
        return s(208 <= o && o <= 29648), o;
      }, a.getNumDataCodewords = function(i, o) {
        return Math.floor(a.getNumRawDataModules(i) / 8) - a.ECC_CODEWORDS_PER_BLOCK[o.ordinal][i] * a.NUM_ERROR_CORRECTION_BLOCKS[o.ordinal][i];
      }, a.reedSolomonComputeDivisor = function(i) {
        if (i < 1 || i > 255)
          throw new RangeError("Degree out of range");
        for (var o = [], c = 0; c < i - 1; c++)
          o.push(0);
        o.push(1);
        for (var l = 1, c = 0; c < i; c++) {
          for (var f = 0; f < o.length; f++)
            o[f] = a.reedSolomonMultiply(o[f], l), f + 1 < o.length && (o[f] ^= o[f + 1]);
          l = a.reedSolomonMultiply(l, 2);
        }
        return o;
      }, a.reedSolomonComputeRemainder = function(i, o) {
        for (var c = o.map(function(_) {
          return 0;
        }), l = function(_) {
          var m = _ ^ c.shift();
          c.push(0), o.forEach(function(b, v) {
            return c[v] ^= a.reedSolomonMultiply(b, m);
          });
        }, f = 0, h = i; f < h.length; f++) {
          var d = h[f];
          l(d);
        }
        return c;
      }, a.reedSolomonMultiply = function(i, o) {
        if (i >>> 8 || o >>> 8)
          throw new RangeError("Byte out of range");
        for (var c = 0, l = 7; l >= 0; l--)
          c = c << 1 ^ (c >>> 7) * 285, c ^= (o >>> l & 1) * i;
        return s(c >>> 8 == 0), c;
      }, a.prototype.finderPenaltyCountPatterns = function(i) {
        var o = i[1];
        s(o <= this.size * 3);
        var c = o > 0 && i[2] == o && i[3] == o * 3 && i[4] == o && i[5] == o;
        return (c && i[0] >= o * 4 && i[6] >= o ? 1 : 0) + (c && i[6] >= o * 4 && i[0] >= o ? 1 : 0);
      }, a.prototype.finderPenaltyTerminateAndCount = function(i, o, c) {
        return i && (this.finderPenaltyAddHistory(o, c), o = 0), o += this.size, this.finderPenaltyAddHistory(o, c), this.finderPenaltyCountPatterns(c);
      }, a.prototype.finderPenaltyAddHistory = function(i, o) {
        o[0] == 0 && (i += this.size), o.pop(), o.unshift(i);
      }, a.MIN_VERSION = 1, a.MAX_VERSION = 40, a.PENALTY_N1 = 3, a.PENALTY_N2 = 3, a.PENALTY_N3 = 40, a.PENALTY_N4 = 10, a.ECC_CODEWORDS_PER_BLOCK = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
        [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
        [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
        [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30]
        // High
      ], a.NUM_ERROR_CORRECTION_BLOCKS = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25],
        [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49],
        [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68],
        [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81]
        // High
      ], a;
    }()
  );
  n.QrCode = e;
  function t(a, i, o) {
    if (i < 0 || i > 31 || a >>> i)
      throw new RangeError("Value out of range");
    for (var c = i - 1; c >= 0; c--)
      o.push(a >>> c & 1);
  }
  function r(a, i) {
    return (a >>> i & 1) != 0;
  }
  function s(a) {
    if (!a)
      throw new Error("Assertion error");
  }
  var u = (
    /** @class */
    function() {
      function a(i, o, c) {
        if (this.mode = i, this.numChars = o, this.bitData = c, o < 0)
          throw new RangeError("Invalid argument");
        this.bitData = c.slice();
      }
      return a.makeBytes = function(i) {
        for (var o = [], c = 0, l = i; c < l.length; c++) {
          var f = l[c];
          t(f, 8, o);
        }
        return new a(a.Mode.BYTE, i.length, o);
      }, a.makeNumeric = function(i) {
        if (!a.isNumeric(i))
          throw new RangeError("String contains non-numeric characters");
        for (var o = [], c = 0; c < i.length; ) {
          var l = Math.min(i.length - c, 3);
          t(parseInt(i.substring(c, c + l), 10), l * 3 + 1, o), c += l;
        }
        return new a(a.Mode.NUMERIC, i.length, o);
      }, a.makeAlphanumeric = function(i) {
        if (!a.isAlphanumeric(i))
          throw new RangeError("String contains unencodable characters in alphanumeric mode");
        var o = [], c;
        for (c = 0; c + 2 <= i.length; c += 2) {
          var l = a.ALPHANUMERIC_CHARSET.indexOf(i.charAt(c)) * 45;
          l += a.ALPHANUMERIC_CHARSET.indexOf(i.charAt(c + 1)), t(l, 11, o);
        }
        return c < i.length && t(a.ALPHANUMERIC_CHARSET.indexOf(i.charAt(c)), 6, o), new a(a.Mode.ALPHANUMERIC, i.length, o);
      }, a.makeSegments = function(i) {
        return i == "" ? [] : a.isNumeric(i) ? [a.makeNumeric(i)] : a.isAlphanumeric(i) ? [a.makeAlphanumeric(i)] : [a.makeBytes(a.toUtf8ByteArray(i))];
      }, a.makeEci = function(i) {
        var o = [];
        if (i < 0)
          throw new RangeError("ECI assignment value out of range");
        if (i < 128)
          t(i, 8, o);
        else if (i < 16384)
          t(2, 2, o), t(i, 14, o);
        else if (i < 1e6)
          t(6, 3, o), t(i, 21, o);
        else
          throw new RangeError("ECI assignment value out of range");
        return new a(a.Mode.ECI, 0, o);
      }, a.isNumeric = function(i) {
        return a.NUMERIC_REGEX.test(i);
      }, a.isAlphanumeric = function(i) {
        return a.ALPHANUMERIC_REGEX.test(i);
      }, a.prototype.getData = function() {
        return this.bitData.slice();
      }, a.getTotalBits = function(i, o) {
        for (var c = 0, l = 0, f = i; l < f.length; l++) {
          var h = f[l], d = h.mode.numCharCountBits(o);
          if (h.numChars >= 1 << d)
            return 1 / 0;
          c += 4 + d + h.bitData.length;
        }
        return c;
      }, a.toUtf8ByteArray = function(i) {
        i = encodeURI(i);
        for (var o = [], c = 0; c < i.length; c++)
          i.charAt(c) != "%" ? o.push(i.charCodeAt(c)) : (o.push(parseInt(i.substring(c + 1, c + 3), 16)), c += 2);
        return o;
      }, a.NUMERIC_REGEX = /^[0-9]*$/, a.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/, a.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:", a;
    }()
  );
  n.QrSegment = u;
})(M || (M = {}));
(function(n) {
  (function(e) {
    var t = (
      /** @class */
      function() {
        function r(s, u) {
          this.ordinal = s, this.formatBits = u;
        }
        return r.LOW = new r(0, 1), r.MEDIUM = new r(1, 0), r.QUARTILE = new r(2, 3), r.HIGH = new r(3, 2), r;
      }()
    );
    e.Ecc = t;
  })(n.QrCode || (n.QrCode = {}));
})(M || (M = {}));
(function(n) {
  (function(e) {
    var t = (
      /** @class */
      function() {
        function r(s, u) {
          this.modeBits = s, this.numBitsCharCount = u;
        }
        return r.prototype.numCharCountBits = function(s) {
          return this.numBitsCharCount[Math.floor((s + 7) / 17)];
        }, r.NUMERIC = new r(1, [10, 12, 14]), r.ALPHANUMERIC = new r(2, [9, 11, 13]), r.BYTE = new r(4, [8, 16, 16]), r.KANJI = new r(8, [8, 10, 12]), r.ECI = new r(7, [0, 0, 0]), r;
      }()
    );
    e.Mode = t;
  })(n.QrSegment || (n.QrSegment = {}));
})(M || (M = {}));
var D = M, Fe = "H", _e = {
  L: D.QrCode.Ecc.LOW,
  M: D.QrCode.Ecc.MEDIUM,
  Q: D.QrCode.Ecc.QUARTILE,
  H: D.QrCode.Ecc.HIGH
}, Et = function() {
  try {
    new Path2D().addPath(new Path2D());
  } catch {
    return !1;
  }
  return !0;
}();
function ze(n) {
  return n in _e;
}
function $e(n, e) {
  e === void 0 && (e = 0);
  var t = [];
  return n.forEach(function(r, s) {
    var u = null;
    r.forEach(function(a, i) {
      if (!a && u !== null) {
        t.push("M".concat(u + e, " ").concat(s + e, "h").concat(i - u, "v1H").concat(u + e, "z")), u = null;
        return;
      }
      if (i === r.length - 1) {
        if (!a)
          return;
        u === null ? t.push("M".concat(i + e, ",").concat(s + e, " h1v1H").concat(i + e, "z")) : t.push("M".concat(u + e, ",").concat(s + e, " h").concat(i + 1 - u, "v1H").concat(u + e, "z"));
        return;
      }
      a && u === null && (u = i);
    });
  }), t.join("");
}
var pe = {
  value: {
    type: String,
    required: !0,
    default: ""
  },
  size: {
    type: Number,
    default: 100
  },
  level: {
    type: String,
    default: Fe,
    validator: function(n) {
      return ze(n);
    }
  },
  background: {
    type: String,
    default: "#fff"
  },
  foreground: {
    type: String,
    default: "#000"
  },
  margin: {
    type: Number,
    required: !1,
    default: 0
  }
}, Ct = ee(ee({}, pe), { renderAs: {
  type: String,
  required: !1,
  default: "canvas",
  validator: function(n) {
    return ["canvas", "svg"].indexOf(n) > -1;
  }
} }), Rt = E({
  name: "QRCodeSvg",
  props: pe,
  setup: function(n) {
    var e = B(0), t = B(""), r = function() {
      var s = n.value, u = n.level, a = n.margin, i = D.QrCode.encodeText(s, _e[u]).getModules();
      e.value = i.length + a * 2, t.value = $e(i, a);
    };
    return r(), Le(r), function() {
      return V("svg", {
        width: n.size,
        height: n.size,
        "shape-rendering": "crispEdges",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 ".concat(e.value, " ").concat(e.value)
      }, [
        V("path", {
          fill: n.background,
          d: "M0,0 h".concat(e.value, "v").concat(e.value, "H0z")
        }),
        V("path", { fill: n.foreground, d: t.value })
      ]);
    };
  }
}), It = E({
  name: "QRCodeCanvas",
  props: pe,
  setup: function(n) {
    var e = B(null), t = function() {
      var r = n.value, s = n.level, u = n.size, a = n.margin, i = n.background, o = n.foreground, c = e.value;
      if (c) {
        var l = c.getContext("2d");
        if (l) {
          var f = D.QrCode.encodeText(r, _e[s]).getModules(), h = f.length + a * 2, d = window.devicePixelRatio || 1, _ = u / h * d;
          c.height = c.width = u * d, l.scale(_, _), l.fillStyle = i, l.fillRect(0, 0, h, h), l.fillStyle = o, Et ? l.fill(new Path2D($e(f, a))) : f.forEach(function(m, b) {
            m.forEach(function(v, w) {
              v && l.fillRect(w + a, b + a, 1, 1);
            });
          });
        }
      }
    };
    return nt(t), Le(t), function() {
      return V("canvas", {
        ref: e,
        style: { width: "".concat(n.size, "px"), height: "".concat(n.size, "px") }
      });
    };
  }
}), Nt = E({
  name: "Qrcode",
  render: function() {
    var n = this.$props, e = n.renderAs, t = n.value, r = n.size, s = n.margin, u = n.level, a = n.background, i = n.foreground, o = r >>> 0, c = s >>> 0, l = ze(u) ? u : Fe;
    return V(e === "svg" ? Rt : It, { value: t, size: o, margin: c, level: l, background: a, foreground: i });
  },
  props: Ct
});
const Pt = { class: "modal show d-block" }, Mt = { class: "modal-dialog modal-lg modal-dialog-centered" }, kt = { class: "modal-content" }, Ot = { class: "modal-header" }, At = /* @__PURE__ */ p("i", { class: "fa-solid fa-qrcode fa-2 me-2" }, null, -1), Tt = /* @__PURE__ */ p("h5", { class: "modal-title" }, "Augmented Reality", -1), Dt = { class: "modal-body text-center" }, Ut = /* @__PURE__ */ p("p", { class: "text-center" }, " Scan with your mobile to start your AR Experience. ", -1), Lt = /* @__PURE__ */ p("p", { class: "small" }, [
  /* @__PURE__ */ ot(" You want to bring this experience to your companies website or shop "),
  /* @__PURE__ */ p("a", {
    class: "ms-2 btn btn-sm btn-primary text-white",
    target: "_blank",
    href: "https://www.renderthat.com/contact-us"
  }, "Contact us")
], -1), Bt = /* @__PURE__ */ p("div", { class: "modal-backdrop fade show" }, null, -1), Kr = /* @__PURE__ */ E({
  __name: "QrCodeModal",
  props: {
    modelUrl: {}
  },
  emits: ["click:close"],
  setup(n, { emit: e }) {
    const t = it(() => `${location.origin}/ar-quick-look?model=${btoa(s.modelUrl)}`), r = e, s = n;
    return (u, a) => (y(), S(Be, null, [
      p("div", Pt, [
        p("div", Mt, [
          p("div", kt, [
            p("div", Ot, [
              At,
              Tt,
              p("button", {
                type: "button",
                class: "btn-close",
                "aria-label": "Close",
                onClick: a[0] || (a[0] = (i) => r("click:close"))
              })
            ]),
            p("div", Dt, [
              st(Nt, {
                value: t.value,
                size: 250,
                level: "L"
              }, null, 8, ["value"]),
              Ut,
              Lt
            ])
          ])
        ])
      ]),
      Bt
    ], 64));
  }
}), Ft = { class: "modal-content" }, zt = { class: "modal-header" }, $t = { class: "modal-title" }, qt = { class: "modal-body" }, Qt = {
  key: 0,
  class: "modal-footer"
}, Xr = /* @__PURE__ */ E({
  __name: "ModalComponent",
  props: {
    title: {
      type: String,
      required: !0
    },
    size: {
      type: String,
      required: !1,
      default: ""
    },
    showCloseIcon: {
      type: Boolean,
      required: !1,
      default: !0
    },
    icon: {
      type: String,
      required: !1,
      default: ""
    },
    classModal: {
      type: String,
      required: !1,
      default: ""
    },
    classBackdrop: {
      type: String,
      required: !1,
      default: ""
    }
  },
  emits: ["click:close"],
  setup(n, { emit: e }) {
    const t = at(), r = e, s = n;
    return (u, a) => (y(), S(Be, null, [
      p("div", {
        class: T(["modal show d-block", s.classModal])
      }, [
        p("div", {
          class: T(["modal-dialog modal-dialog-centered", s.size])
        }, [
          p("div", Ft, [
            p("div", zt, [
              s.icon ? (y(), S("i", {
                key: 0,
                class: T(["me-2 fa-2", s.icon])
              }, null, 2)) : ne("", !0),
              p("h5", $t, ue(s.title), 1),
              n.showCloseIcon ? (y(), S("button", {
                key: 1,
                type: "button",
                class: "btn-close",
                "aria-label": "Close",
                onClick: a[0] || (a[0] = (i) => r("click:close"))
              })) : ne("", !0)
            ]),
            p("div", qt, [
              I(u.$slots, "body")
            ]),
            ct(t).footer ? (y(), S("div", Qt, [
              I(u.$slots, "footer")
            ])) : ne("", !0)
          ])
        ], 2)
      ], 2),
      p("div", {
        class: T(["modal-backdrop fade show", s.classBackdrop])
      }, null, 2)
    ], 64));
  }
}), xt = ["id"], jt = { "data-bs-theme": "dark" }, Zr = /* @__PURE__ */ E({
  __name: "BaseAppContainer",
  props: {
    id: {}
  },
  setup(n) {
    return (e, t) => (y(), S("div", { id: e.id }, [
      p("div", jt, [
        I(e.$slots, "default")
      ])
    ], 8, xt));
  }
}), Ht = {}, Vt = { class: "position-relative w-100 vh-100 overflow-hidden" };
function Yt(n, e) {
  return y(), S("div", Vt, [
    I(n.$slots, "default")
  ]);
}
const en = /* @__PURE__ */ G(Ht, [["render", Yt]]), Wt = /* @__PURE__ */ E({
  __name: "VerticalOverlay",
  props: {
    pos: { default: "left" }
  },
  setup(n) {
    return (e, t) => (y(), S("div", {
      class: T(["overlay", e.pos])
    }, [
      I(e.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), tn = /* @__PURE__ */ G(Wt, [["__scopeId", "data-v-ae0e1098"]]), rn = ut("userStore", () => {
  const n = B("default");
  function e(t) {
    n.value = t;
  }
  return {
    role: n,
    updateRole: e
  };
});
var O = /* @__PURE__ */ ((n) => (n[n.Image = 1] = "Image", n[n.Model3D = 2] = "Model3D", n[n.Video = 4] = "Video", n[n.Pdf = 8] = "Pdf", n[n.Unknown = 16] = "Unknown", n))(O || {});
function nn(n) {
  switch (n) {
    case "image/jpeg":
    case "image/png":
    case "image/bmp":
    case "image/svg+xml":
    case "image/webp":
    case "image/vnd.adobe.photoshop":
    case "image/tiff":
      return O.Image;
    case "video/mp4":
      return O.Video;
    case "application/pdf":
      return O.Pdf;
    case "model/gltf-binary":
    case "application/octet-stream":
      return O.Model3D;
    default:
      return O.Unknown;
  }
}
function sn(n) {
  switch (n) {
    case "image/jpeg":
    case "image/png":
    case "image/bmp":
    case "image/tiff":
    case "video/mp4":
    case "application/pdf":
    case "model/gltf-binary":
    case "application/vnd.adobe.illustrator":
      return !0;
    default:
      return !1;
  }
}
function on(n) {
  switch (n) {
    case "image/tiff":
    case "image/vnd.adobe.photoshop":
      return !1;
    default:
      return !0;
  }
}
function an(n, e) {
  const t = [
    {
      id: 0,
      label: "Canceled",
      clickUp: ["cancelled"],
      value: 0
    },
    {
      id: 1,
      label: "Initialized",
      clickUp: ["no task", "queued"],
      value: 16.6666666667
    },
    {
      id: 2,
      label: "References requested",
      clickUp: ["references requested"],
      value: 33.3333333334
    },
    {
      id: 3,
      label: "In Progress",
      clickUp: ["in progress", "file check", "post production"],
      value: 50.0000000001
    },
    {
      id: 4,
      label: "Review",
      clickUp: ["final review", "shaded model review", "geometry review"],
      value: 66.6666666668
    },
    {
      id: 5,
      label: "Finalizing",
      clickUp: ["finalizing"],
      // Before, we had "data check" here, but that is now in the "In Progress" column.
      value: 83.3333333335
    },
    {
      id: 6,
      label: "Ready",
      clickUp: ["final"],
      value: 100.0000000002
    }
  ], r = [
    {
      id: 0,
      label: "Canceled",
      clickUp: ["cancelled"],
      value: 0
    },
    {
      id: 1,
      label: "Initialized",
      clickUp: [
        "waiting for designer",
        "initialized",
        "reference upload",
        "check references"
      ],
      value: 16.6666666667 * 1
    },
    {
      id: 2,
      label: "In Progress",
      clickUp: [
        "shading",
        "ready for unwrapping",
        "3d modeling",
        "shd - needs correction",
        "mod - needs correction",
        "correction",
        "post production"
      ],
      value: 16.6666666667 * 2
    },
    {
      id: 3,
      label: "QA",
      clickUp: ["modeling qa", "shading qa"],
      value: 16.6666666667 * 3
    },
    {
      id: 4,
      label: "Review",
      clickUp: [
        "shaded model review",
        "final review",
        "geometry review",
        "geometry review check",
        "shaded model review check",
        "final review check"
      ],
      value: 16.6666666667 * 4
    },
    {
      id: 5,
      label: "Finalizing",
      clickUp: ["create final rendering"],
      value: 16.6666666667 * 5
    },
    {
      id: 6,
      label: "Final",
      clickUp: ["data check", "final", "final model"],
      value: 16.6666666667 * 6
    }
  ], s = e === "asset" ? r : t;
  if (n) {
    const u = s.find(
      (a) => a.clickUp.includes(n.toLowerCase())
    );
    return u || {
      id: 1,
      label: "Initialized",
      clickUp: ["no task", "queued"],
      value: 16.6666666667 * 1
    };
  } else
    return {
      id: 1,
      label: "Initialized",
      clickUp: ["no task", "queued"],
      value: 16.6666666667 * 1
    };
}
function W(n) {
  "@babel/helpers - typeof";
  return W = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, W(n);
}
function Gt(n) {
  return Zt(n) || Xt(n) || Kt(n) || Jt();
}
function Jt() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Kt(n, e) {
  if (n) {
    if (typeof n == "string") return le(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return le(n, e);
  }
}
function Xt(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function Zt(n) {
  if (Array.isArray(n)) return le(n);
}
function le(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function er(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Re(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, rr(r.key), r);
  }
}
function tr(n, e, t) {
  return e && Re(n.prototype, e), t && Re(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function rr(n) {
  var e = nr(n, "string");
  return W(e) === "symbol" ? e : String(e);
}
function nr(n, e) {
  if (W(n) !== "object" || n === null) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e || "default");
    if (W(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
var ir = function(e, t, r, s) {
  if (e) {
    for (var u, a = e.length; a--; )
      if (u = e[a], (u.t === t || t === null && !s) && (r === u.h || r === null && !s) && (e.splice(a, 1), s))
        return !0;
  }
  return !s;
}, sr = /* @__PURE__ */ function() {
  function n() {
    er(this, n), this._evs = {}, this._qh = null;
  }
  return tr(n, [{
    key: "on",
    value: function(t, r, s, u) {
      var a, i, o, c;
      if (typeof r == "function" && (u = s, s = r, r = t, t = null), c = {
        t: t || null,
        h: s
      }, !r)
        o = u || "", i = this._evs[o], i ? i.push(c) : this._evs[o] = [c];
      else
        for (u = u ? u + "." : "", r = r.match(/\S+/g) || [], a = 0; a < r.length; a++)
          o = u + r[a], i = this._evs[o], i ? i.push(c) : this._evs[o] = [c];
      return this;
    }
    /**
     * Remove an event handler.
     * @param {object} [target] An optional target object. The handler will only be removed if target matches the target of the handler.
     * @param {?string} events One or more space-separated events (eg. 'disconnect'). Null or empty means any event.
     * @param {function} [handler] An option handler function. The handler will only be remove if it is the same handler.
     * @param {string} [namespace] Namespace string that will be added, separated with a dot, to every event name.
     * @param {boolean} [strict] Flag for strict mode where an error will be thrown if the handler doesn't exist.
     * @returns {this}
     */
  }, {
    key: "off",
    value: function(t, r, s, u, a) {
      var i, o, c;
      for ((t === null || typeof t == "string") && (a = u, u = s, s = r, r = t, t = null), r ? (u = u ? u + "." : "", r = r.match(/\S+/g) || []) : (r = [u || ""], u = ""), i = 0; i < r.length; i++) {
        if (c = u + r[i], o = this._evs[c], !ir(o, t, s, a)) {
          var l = new Error("Event handler not found");
          throw console.error(l, {
            target: t,
            events: r,
            handler: s,
            namespace: u
          }), l;
        }
        o && (o.length || delete this._evs[c]);
      }
      return this;
    }
    /**
     * Emits an event and triggers the base handler to be called, followed by any other handler bound.
     * @param {object} [target] Target object of the event
     * @param {string} event Name of the event. May include the namespace, if the namespace parameter is not provided.
     * @param {object} [data] Event data object. May be modified by the base handler, but shouldn't be changed any other handler.
     * @param {string} [namespace] Namespace string that will be added, separated with a dot, before the event name.
     * @returns {this}
     */
  }, {
    key: "emit",
    value: function(t, r, s, u) {
      var a, i, o, c, l;
      for (typeof t == "string" && (u = s, s = r, r = t, t = null), r = (u ? u + "." : "") + r, c = r; ; ) {
        if (i = this._evs[c], i)
          for (l = (c ? r.substr(c.length + 1) : r) || null, a = i.length; a--; )
            o = i[a], typeof o.h == "function" && (o.t === null || o.t == t) && this._exec([s, t, r, l, o.h]);
        if (!c)
          break;
        a = c.lastIndexOf("."), c = a == -1 ? "" : c.substr(0, a);
      }
      return this;
    }
  }, {
    key: "_exec",
    value: function(t) {
      var r = this;
      if (this._qh) {
        this._qh.push(t);
        return;
      }
      this._qh = [t], setTimeout(function() {
        for (var s; t = r._qh.shift(); ) {
          s = t.pop();
          try {
            s.apply(void 0, Gt(t));
          } catch (u) {
            console.error(u);
          }
        }
        r._qh = null;
      }, 0);
    }
  }]), n;
}(), or = new sr();
function F(n) {
  "@babel/helpers - typeof";
  return F = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, F(n);
}
var ar = {
  any: {
    default: function() {
      return null;
    },
    assert: function(e) {
    },
    fromString: function(e) {
      return e;
    }
  },
  string: {
    default: function() {
      return "";
    },
    assert: function(e) {
      if (typeof e != "string")
        throw new Error("Not a string");
    },
    fromString: function(e) {
      return String(e);
    }
  },
  "?string": {
    default: function() {
      return null;
    },
    assert: function(e) {
      if (typeof e != "string" && e !== null)
        throw new Error("Not a string or null");
    },
    fromString: function(e) {
      return String(e);
    }
    // Not possible to set null
  },
  number: {
    default: function() {
      return 0;
    },
    assert: function(e) {
      if (typeof e != "number")
        throw new Error("Not a number");
    },
    fromString: function(e) {
      if (e = Number(e), isNaN(e))
        throw new Error("Not a number format");
      return e;
    }
  },
  "?number": {
    default: function() {
      return null;
    },
    assert: function(e) {
      if (typeof e != "number" && e !== null)
        throw new Error("Not a number or null");
    },
    fromString: function(e) {
      if (e = !e || e.toLowerCase() == "null" ? null : Number(e), isNaN(e))
        throw new Error("Not a number format");
      return e;
    }
  },
  boolean: {
    default: function() {
      return !1;
    },
    assert: function(e) {
      if (typeof e != "boolean")
        throw new Error("Not a boolean");
    },
    fromString: function(e) {
      if (e = e.toLowerCase(), e == "true" || e == "1" || e == "yes")
        e = !0;
      else if (e == "false" || e == "0" || e == "no")
        e = !1;
      else
        throw new Error("Not a boolean format");
      return e;
    }
  },
  "?boolean": {
    default: function() {
      return null;
    },
    assert: function(e) {
      if (typeof e != "boolean" && e !== null)
        throw new Error("Not a boolean or null");
    },
    fromString: function(e) {
      if (e = e.toLowerCase(), e == "true" || e == "1" || e == "yes")
        e = !0;
      else if (e == "false" || e == "0" || e == "no")
        e = !1;
      else if (e == "null")
        e = null;
      else
        throw new Error("Not a nullable boolean format");
      return e;
    }
  },
  object: {
    default: function() {
      return {};
    },
    assert: function(e) {
      if (F(e) !== "object" || e === null)
        throw new Error("Not an object");
    },
    fromString: function(e) {
      return JSON.parse(e);
    }
  },
  "?object": {
    default: function() {
      return null;
    },
    assert: function(e) {
      if (F(e) !== "object")
        throw new Error("Not an object or null");
    },
    fromString: function(e) {
      return JSON.parse(e);
    }
  },
  function: {
    default: function() {
      return function() {
      };
    },
    assert: function(e) {
      if (typeof e != "function")
        throw new Error("Not a function");
    },
    fromString: function(e) {
      return function() {
      };
    }
  },
  "?function": {
    default: function() {
      return null;
    },
    assert: function(e) {
      if (typeof e != "function" && e !== null)
        throw new Error("Not a function or null");
    },
    fromString: function(e) {
      return null;
    }
  }
}, te = function(e, t, r) {
  var s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
  if ((!t || F(t) != "object") && (t = {}), !r || F(r) != "object")
    throw new Error("Invalid definition");
  var u = !1, a = {};
  for (var i in r) {
    var o = r[i];
    typeof o == "string" && (o = {
      type: o
    });
    var c = ar[o.type];
    if (!c)
      throw new Error("Invalid definition type: " + o.type);
    var l = o.hasOwnProperty("property") ? o.property : i;
    if (e.hasOwnProperty(l) || (u = !0, a[l] = void 0, e[l] = o.hasOwnProperty("default") ? o.default : c.default()), !!t.hasOwnProperty(i)) {
      var f = t[i];
      if (!(typeof f > "u"))
        try {
          typeof f == "string" && (f = c.fromString(f)), o.filter && (f = o.filter(f)), c.assert(f), o.assert && o.assert(f), e[l] !== f && (u = !0, a[l] = e[l], e[l] = f);
        } catch (h) {
          if (s)
            throw h;
        }
    }
  }
  return u ? a : null;
}, qe = function(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, s = {};
  return te(s, e, t, r), s;
}, cr = 5e3;
class Ie {
  /**
   * Creates a CacheItem instance
   * @param {string} rid Resource ID
   * @param {function} unsubscribe Unsubscribe callback
   */
  constructor(e, t) {
    this.rid = e, this._unsubscribe = t, this.type = null, this.item = null, this.direct = 0, this.indirect = 0, this.subscribed = 0, this.promise = null;
  }
  /**
   * Adds or subtracts from the subscribed counter.
   * @param {number} dir Value to add. If 0, the subscribed counter will be set to 0.
   */
  addSubscribed(e) {
    this.subscribed += e || -this.subscribed, !this.subscribed && this.unsubTimeout && (clearTimeout(this.unsubTimeout), this.unsubTimeout = null);
  }
  setPromise(e) {
    return this.item || (this.promise = e), e;
  }
  setItem(e, t) {
    return this.item = e, this.type = t, this.promise = null, this._checkUnsubscribe(), this;
  }
  setType(e) {
    return this.type = e, this;
  }
  addDirect() {
    this.unsubTimeout && (clearTimeout(this.unsubTimeout), this.unsubTimeout = null), this.direct++;
  }
  removeDirect() {
    if (this.direct--, this.direct < 0)
      throw "Direct count reached below 0";
    this.subscribed ? this._checkUnsubscribe() : this._unsubscribe(this);
  }
  resetTimeout() {
    this.unsubTimeout && (clearTimeout(this.unsubTimeout), this.unsubTimeout = null, this._checkUnsubscribe());
  }
  _checkUnsubscribe() {
    !this.subscribed || this.direct || this.unsubTimeout || (this.unsubTimeout = setTimeout(() => this._unsubscribe(this), cr));
  }
  addIndirect() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    if (this.indirect += e, this.indirect < 0)
      throw "Indirect count reached below 0";
  }
}
class Ne {
  /**
   * Creates a TypeList instance
   * @param {resourceFactoryCallback} defaultFactory Default factory function
   */
  constructor(e) {
    this.root = {}, this.defaultFactory = e;
  }
  /**
   * Adds a resource factory callback to a pattern.
   * The pattern may use the following wild cards:
   * * The asterisk (*) matches any part at any level of the resource name.
   * * The greater than symbol (>) matches one or more parts at the end of a resource name, and must be the last part.
   * @param {string} pattern Pattern of the resource type.
   * @param {resourceFactoryCallback} factory Resource factory callback
   */
  addFactory(e, t) {
    var r = e.split("."), s = this.root, u, a = !1;
    for (var i of r) {
      var o = i.length;
      if (!o || a)
        throw new Error("Invalid pattern");
      o > 1 ? s.nodes ? u = s.nodes[i] = s.nodes[i] || {} : (s.nodes = {}, u = s.nodes[i] = {}) : i[0] === "*" ? u = s.pwc = s.pwc || {} : i[0] === ">" ? (u = s.fwc = s.fwc || {}, a = !0) : s.nodes ? u = s.nodes[i] = s.nodes[i] || {} : (s.nodes = {}, u = s.nodes[i] = {}), s = u;
    }
    if (s.factory)
      throw new Error("Pattern already registered");
    s.factory = t;
  }
  /**
   * Removes a resource factory callback.
   * @param {string} pattern Pattern of the resource type.
   * @returns {?resourceFactoryCallback} Factory callback or undefined if no callback is registered on the pattern
   */
  removeFactory(e) {
    var t = e.split("."), r = this.root, s, u = !1, a;
    for (var i of t) {
      if (s = null, a = i.length, a && !u && (a > 1 ? r.nodes && (s = r.nodes[i]) : i[0] === "*" ? s = r.pwc : i[0] === ">" ? (s = r.fwc, u = !0) : r.nodes && (s = r.nodes[i])), !s)
        return;
      r = s;
    }
    var o = r.factory;
    return delete r.factory, o;
  }
  /**
   * Gets the factory callback that best matches the pattern.
   * Matching will give priority to text, then to *-wildcards, and last to >-wildcards.
   * @param {string} rid Resource ID
   * @returns {resourceFactoryCallback} Factory callback
   */
  getFactory(e) {
    var t = e.replace(/\?.*$/, "").split(".");
    return this._match(t, 0, this.root) || this.defaultFactory;
  }
  _match(e, t, r) {
    for (var s = e[t++], u = 2, a = r.nodes ? r.nodes[s] : void 0; u--; ) {
      if (a)
        if (e.length === t) {
          if (a.factory)
            return a.factory;
        } else {
          var i = this._match(e, t, a);
          if (i)
            return i;
        }
      a = r.pwc;
    }
    return a = r.fwc, a && a.factory;
  }
}
class Qe {
  /**
   * Creates an ResCollection instance
   * @param {ResClient} api ResClient instance
   * @param {string} rid Resource id.
   * @param {object} [opt] Optional settings
   * @param {function} [opt.idCallback] Id callback function.
   */
  constructor(e, t, r) {
    r = qe(r, {
      idCallback: {
        type: "?function"
      }
    }), this._api = e, this._rid = t, this._idCallback = r.idCallback, this._map = this._idCallback ? {} : null, this._list = null;
  }
  /**
   * ResClient instance.
   * @returns {ResClient} ResClient instance
   */
  getClient() {
    return this._api;
  }
  /**
   * Collection resource ID
   * @returns {string} Resource ID
   */
  getResourceId() {
    return this._rid;
  }
  /**
   * Length of the collection
   */
  get length() {
    return this._list.length;
  }
  /**
   * Internal collection array. Do not mutate directly.
   */
  get list() {
    return this._list;
  }
  /**
   * Attach a collection event handler function for one or more events.
   * If no event or handler is provided, the collection will still be considered listened to,
   * until a matching off call without arguments is made.
   * Available events are 'add', 'remove', and custom events.
   * @param {?string} [events] One or more space-separated events. Null means any event.
   * @param {ResCollection~addCallback|ResCollection~removeCallback|eventCallback} [handler] Handler function to execute when the event is emitted.
   * @returns {this}
   */
  on(e, t) {
    return this._api.resourceOn(this._rid, e, t), this;
  }
  /**
  * Remove a collection event handler function.
  * Available events are 'add', 'remove', and custom events.
  * @param {?string} [events] One or more space-separated events. Null means any event.
  * @param {ResCollection~addCallback|ResCollection~removeCallback|eventCallback} [handler] Handler function to remove.
  * @returns {this}
  */
  off(e, t) {
    return this._api.resourceOff(this._rid, e, t), this;
  }
  /**
   * Get an item from the collection by id.
   * Requires that id callback is defined for the collection.
   * @param {string} id Id of the item
   * @returns {*} Item with the id. Undefined if key doesn't exist
   */
  get(e) {
    return this._hasId(), this._map[e];
  }
  /**
   * Retrieves the order index of an item.
   * @param {*} item Item to find
   * @returns {number} Order index of the first matching item. -1 if the item doesn't exist.
   */
  indexOf(e) {
    return this._list.indexOf(e);
  }
  /**
   * Gets an item from the collection by index position
   * @param {number} idx  Index of the item
   * @returns {*} Item at the given index. Undefined if the index is out of bounds.
   */
  atIndex(e) {
    return this._list[e];
  }
  /**
   * Calls a method on the collection.
   * @param {string} method Method name
   * @param {*} params Method parameters
   * @returns {Promise.<object>} Promise of the call result.
   */
  call(e, t) {
    return this._api.call(this._rid, e, t);
  }
  /**
   * Calls an auth method on the collection.
   * @param {string} method Auth method name
   * @param {*} params Method parameters
   * @returns {Promise.<object>} Promise of the auth result.
   */
  auth(e, t) {
    return this._api.authenticate(this._rid, e, t);
  }
  /**
   * Returns a shallow clone of the internal array.
   * @returns {Array.<*>} Clone of internal array
   */
  toArray() {
    return this._list.slice();
  }
  /**
   * Initializes the collection with a data array.
   * Should only be called by the ResClient instance.
   * @param {Array.<*>} data ResCollection data array
   * @private
   */
  __init(e) {
    this._list = e || [], this._idCallback && (this._map = {}, this._list.forEach((t) => {
      var r = String(this._idCallback(t));
      if (this._map[r])
        throw new Error("Duplicate id - " + r);
      this._map[r] = t;
    }));
  }
  /**
   * Add an item to the collection.
   * Should only be called by the ResClient instance.
   * @param {*} item Item
   * @param {idx} [idx] Index value of where to insert the item.
   * @private
   */
  __add(e, t) {
    if (this._list.splice(t, 0, e), this._idCallback) {
      var r = String(this._idCallback(e));
      if (this._map[r])
        throw new Error("Duplicate id - " + r);
      this._map[r] = e;
    }
  }
  /**
   * Remove an item from the collection.
   * Should only be called by the ResClient instance.
   * @param {number} idx Index of the item to remove
   * @returns {*} Removed item or undefined if no item was removed
   * @private
   */
  __remove(e) {
    var t = this._list[e];
    return this._list.splice(e, 1), this._idCallback && delete this._map[this._idCallback(t)], t;
  }
  _hasId() {
    if (!this._idCallback)
      throw new Error("No id callback defined");
  }
  toJSON() {
    return this._list.map((e) => e !== null && typeof e == "object" && e.toJSON ? e.toJSON() : e);
  }
  [Symbol.iterator]() {
    var e = 0, t = this._list || [], r = t.length;
    return {
      next: function() {
        return {
          value: t[e++],
          done: e > r
        };
      }
    };
  }
}
function he(n, e) {
  if (n === e) return !0;
  if (n && e && typeof n == "object" && typeof e == "object") {
    var t, r, s;
    if (Array.isArray(n)) {
      if (t = n.length, t != e.length) return !1;
      for (r = t; r-- !== 0; )
        if (!he(n[r], e[r])) return !1;
      return !0;
    }
    if (s = Object.keys(n), t = s.length, t !== Object.keys(e).length) return !1;
    for (r = t; r-- !== 0; ) if (!e.hasOwnProperty(s[r])) return !1;
    for (r = t; r-- !== 0; ) {
      var u = s[r];
      if (!he(n[u], e[u])) return !1;
    }
    return !0;
  }
  return !1;
}
function j(n, e) {
  return typeof n == "object" && n !== null && typeof n.equals == "function" ? n.equals(e) : he(n, e);
}
class xe {
  /**
   * Creates a ResModel instance
   * @param {ResClient} api ResClient instance
   * @param {string} rid Resource id.
   * @param {object} [opt] Optional parameters.
   * @param {object} [opt.definition] Object definition. If not provided, any value will be allowed.
   */
  constructor(e, t, r) {
    te(this, r, {
      definition: {
        type: "?object",
        property: "_definition"
      }
    }), this._rid = t, this._api = e, this._props = {};
  }
  /**
   * Model properties.
   * @returns {object} Anonymous object with all model properties.
   */
  get props() {
    return this._props;
  }
  /**
   * ResClient instance.
   * @returns {ResClient} ResClient instance
   */
  getClient() {
    return this._api;
  }
  /**
   * Model resource ID
   * @returns {string} Resource ID
   */
  getResourceId() {
    return this._rid;
  }
  /**
   * Attach a model event handler function for one or more events.
   * If no event or handler is provided, the model will still be considered listened to,
   * until a matching off call without arguments is made.
   * Available events are 'change', or custom events.
   * @param {?string} [events] One or more space-separated events. Null means any event.
   * @param {ResModel~changeCallback|eventCallback} [handler] Handler function to execute when the event is emitted.
   * @returns {this}
   */
  on(e, t) {
    return this._api.resourceOn(this._rid, e, t), this;
  }
  /**
  * Remove a model event handler function.
  * Available events are 'change', or custom events.
  * @param {?string} events One or more space-separated events. Null means any event.
  * @param {ResModel~changeCallback|eventCallback} [handler] Handler function to remove.
  * @returns {this}
  */
  off(e, t) {
    return this._api.resourceOff(this._rid, e, t), this;
  }
  /**
   * Calls the set method to update model properties.
   * @param {object} props Properties. Set value to undefined to delete a property.
   * @returns {Promise.<object>} Promise of the call being completed.
   */
  set(e) {
    return this._api.setModel(this._rid, e);
  }
  /**
   * Calls a method on the model.
   * @param {string} method Method name
   * @param {*} params Method parameters
   * @returns {Promise.<object>} Promise of the call result.
   */
  call(e, t) {
    return this._api.call(this._rid, e, t);
  }
  /**
   * Calls an auth method on the model.
   * @param {string} method Auth method name
   * @param {*} params Method parameters
   * @returns {Promise.<object>} Promise of the auth result.
   */
  auth(e, t) {
    return this._api.authenticate(this._rid, e, t);
  }
  /**
   * Initializes the model with a data object.
   * Should only be called by the ResClient instance.
   * @param {object} data Data object
   * @private
   */
  __init(e) {
    this.__update(e);
  }
  /**
   * Updates the model.
   * Should only be called by the ResClient instance.
   * @param {object} props Properties to update
   * @param {boolean} reset Flag that sets if missing values should be deleted.
   * @returns {?object} Changed properties
   * @private
   */
  __update(e, t) {
    if (!e)
      return null;
    var r = null, s, u, a = this._props;
    if (t) {
      e = Object.assign({}, e);
      for (var i in a)
        e.hasOwnProperty(i) || (e[i] = void 0);
    }
    if (this._definition) {
      r = te(a, e, this._definition);
      for (var o in r)
        (this.hasOwnProperty(o) || !this[o]) && o[0] !== "_" && (s = a[o], s === void 0 ? delete this[o] : this[o] = s);
    } else
      for (var c in e)
        s = e[c], u = (this.hasOwnProperty(c) || !this[c]) && c[0] !== "_", j(a[c], s) || (r = r || {}, r[c] = a[c], s === void 0 ? (delete a[c], u && delete this[c]) : (a[c] = s, u && (this[c] = s)));
    return r;
  }
  toJSON() {
    var e = this._definition ? qe(this._props, this._definition) : Object.assign({}, this._props);
    for (var t in e) {
      var r = e[t];
      typeof r == "object" && r !== null && r.toJSON && (e[t] = r.toJSON());
    }
    return e;
  }
}
class fe {
  constructor(e, t, r) {
    this.rid = e, t && (this.method = t, this.params = r);
  }
  __init(e) {
    return this._code = e.code || "system.unknownError", this._message = e.message || "Unknown error", this._data = e.data, this;
  }
  /**
   * Error code
   * @type {string}
   */
  get code() {
    return this._code;
  }
  /**
   * Error message
   * @type {string}
   */
  get message() {
    return this._message;
  }
  /**
   * Error data object
   * @type {*}
   */
  get data() {
    return this._data;
  }
  /**
   * Error resource ID
   * @returns {string} Resource ID
   */
  getResourceId() {
    return this.rid;
  }
}
class ve {
  /**
   * Creates a ResRef instance
   * @param {ResClient} api ResClient instance
   * @param {string} rid Resource id.
   */
  constructor(e, t) {
    this._rid = t, this._api = e;
  }
  /**
   * Referenced resource ID.
   * @returns {string} Resource ID.
   */
  get rid() {
    return this._rid;
  }
  /**
   * Get referenced resource.
   * @return {Promise.<(ResModel|ResCollection)>} Promise of the resource.
   */
  get() {
    return this._api.get(this._rid);
  }
  /**
   * Tests if another ResRef object is equivalent to this instance.
   * @param {*} o Value to test equality against.
   * @returns {boolean} True if equal, otherwise false.
   */
  equals(e) {
    return e instanceof ve && e._api === this._api && e._rid === this._rid;
  }
  toJSON() {
    return {
      rid: this._rid
    };
  }
}
var ur = function(e, t) {
  return new xe(e, t);
}, lr = function(e, t) {
  return new Qe(e, t);
}, hr = function(e, t) {
  return new fe(t);
}, me = function(e) {
  if (!e) return 0;
  for (var t = e.split("."), r = 0, s = 0; s < 3; s++)
    r = r * 1e3 + Number(t[s]);
  return r;
}, X = function(e) {
  return e !== null && typeof e == "object" && typeof e.getResourceId == "function" ? e.getResourceId() : null;
}, A = "collection", H = "model", je = "error", ie = [H, A, je], fr = {
  action: "delete"
}, dr = "resclient", _r = 3e3, pr = 2e3, se = 0, x = 1, oe = 2, ae = 3, vr = "1.2.1", ce = me("1.1.1"), mr = me("1.2.1");
class gr {
  /**
   * Creates a ResClient instance
   * @param {string|ResClient~websocketFactory} hostUrlOrFactory Websocket host path, or websocket factory function. Path may be relative to current path.
   * @param {object} [opt] Optional parameters.
   * @param {function} [opt.onConnect] On connect callback called prior resolving the connect promise and subscribing to stale resources. May return a promise.
   * @param {string} [opt.namespace] Event bus namespace. Defaults to 'resclient'.
   * @param {bool} [opt.debug] Flag to debug log all WebSocket communication. Defaults to false.
   * @param {module:modapp~EventBus} [opt.eventBus] Event bus.
   */
  constructor(e, t) {
    this.hostUrl = null, typeof e == "function" ? this.wsFactory = e : (this.hostUrl = this._resolvePath(e), this.wsFactory = () => new WebSocket(this.hostUrl)), te(this, t, {
      onConnect: {
        type: "?function"
      },
      namespace: {
        type: "string",
        default: dr
      },
      debug: {
        type: "boolean",
        default: !1
      },
      eventBus: {
        type: "object",
        default: or
      }
    }), this.tryConnect = !1, this.connected = !1, this.ws = null, this.requests = {}, this.reqId = 1, this.cache = {}, this.stale = null, this.connectPromise = null, this.connectCallback = null, this.types = {
      model: {
        id: H,
        list: new Ne(ur),
        prepareData: (r) => {
          var s = {};
          for (var u in r)
            s[u] = this._prepareValue(r[u], !0);
          return s;
        },
        getFactory: function(s) {
          return this.list.getFactory(s);
        },
        synchronize: this._syncModel.bind(this)
      },
      collection: {
        id: A,
        list: new Ne(lr),
        prepareData: (r) => r.map((s) => this._prepareValue(s, !0)),
        getFactory: function(s) {
          return this.list.getFactory(s);
        },
        synchronize: this._syncCollection.bind(this)
      },
      error: {
        id: je,
        prepareData: (r) => r,
        getFactory: (r) => hr,
        synchronize: () => {
        }
      }
    }, this._handleOnopen = this._handleOnopen.bind(this), this._handleOnerror = this._handleOnerror.bind(this), this._handleOnmessage = this._handleOnmessage.bind(this), this._handleOnclose = this._handleOnclose.bind(this), this._unsubscribe = this._unsubscribe.bind(this);
  }
  /**
   * RES protocol level supported by this client version.
   * @returns {string} Supported RES protocol version.
   */
  get supportedProtocol() {
    return vr;
  }
  /**
   * Connects the instance to the server.
   * Can be called even if a connection is already established.
   * @returns {Promise} A promise to the established connection.
   */
  connect() {
    return this.tryConnect = !0, this.connectPromise || (this.connectPromise = new Promise((e, t) => {
      this.connectCallback = {
        resolve: e,
        reject: t
      }, this.ws = this.wsFactory(), this.ws.onopen = this._handleOnopen, this.ws.onerror = this._handleOnerror, this.ws.onmessage = this._handleOnmessage, this.ws.onclose = this._handleOnclose;
    }), this.connectPromise.catch((e) => this._emit("connectError", e))), this.connectPromise;
  }
  /**
   * Disconnects any current connection and stops attempts
   * of reconnecting.
   */
  disconnect() {
    if (this.tryConnect = !1, this.ws) {
      var e = this.ws, t = {
        code: "system.disconnect",
        message: "Disconnect called"
      };
      e.onclose = null, this._handleOnclose(t), e.close(), this._connectReject(t);
    }
  }
  /**
   * Gets the host URL to the RES API
   * @returns {string} Host URL
   */
  getHostUrl() {
    return this.hostUrl;
  }
  /**
   * Attach an event handler function for one or more instance events.
   * Available events are 'connect', 'disconnect', and 'error'.
   * @param {?string} events One or more space-separated events. Null means any event.
   * @param {ResClient~connectCallback|ResClient~disconnectCallback|ResClient~errorCallback} handler Handler function to execute when the event is emitted.
   */
  on(e, t) {
    this.eventBus.on(this, e, t, this.namespace);
  }
  /**
   * Remove an instance event handler.
   * Available events are 'connect', 'disconnect', and 'error'.
   * @param {?string} events One or more space-separated events. Null means any event.
   * @param {ResClient~connectCallback|ResClient~disconnectCallback|ResClient~errorCallback} [handler] Handler function to remove.
   */
  off(e, t) {
    this.eventBus.off(this, e, t, this.namespace);
  }
  /**
   * Sets the onConnect callback.
   * @param {?ResClient~onConnectCallback} onConnect On connect callback called prior resolving the connect promise and subscribing to stale resources. May return a promise.
   * @returns {this}
   */
  setOnConnect(e) {
    return this.onConnect = e, this;
  }
  /**
   * Model factory callback
   * @callback ResClient~modelFactory
   * @param {ResClient} api ResClient instance
   * @param {string} rid Resource ID
   * @returns {ResModel} Model instance object.
   */
  /**
   * Register a model type.
   * The pattern may use the following wild cards:
   * * The asterisk (*) matches any part at any level of the resource name.
   * * The greater than symbol (>) matches one or more parts at the end of a resource name, and must be the last part.
   * @param {string} pattern Pattern of the model type.
   * @param {ResClient~modelFactory} factory Model factory callback
   * @returns {this}
   */
  registerModelType(e, t) {
    return this.types.model.list.addFactory(e, t), this;
  }
  /**
   * Unregister a previously registered model type pattern.
   * @param {string} pattern Pattern of the model type.
   * @returns {ResClient~modelFactory} Unregistered model factory callback
   */
  unregisterModelType(e) {
    return this.types.model.list.removeFactory(e);
  }
  /**
   * Collection factory callback
   * @callback ResClient~collectionFactory
   * @param {ResClient} api ResClient instance
   * @param {string} rid Resource ID
   * @returns {ResCollection} Collection instance object.
   */
  /**
   * Register a collection type.
   * The pattern may use the following wild cards:
   * * The asterisk (*) matches any part at any level of the resource name.
   * * The greater than symbol (>) matches one or more parts at the end of a resource name, and must be the last part.
   * @param {string} pattern Pattern of the collection type.
   * @param {ResClient~collectionFactory} factory Collection factory callback
   * @returns {this}
   */
  registerCollectionType(e, t) {
    return this.types.collection.list.addFactory(e, t), this;
  }
  /**
   * Unregister a previously registered collection type pattern.
   * @param {string} pattern Pattern of the collection type.
   * @returns {ResClient~collectionFactory} Unregistered collection factory callback
   */
  unregisterCollectionType(e) {
    return this.types.collection.list.removeFactory(e);
  }
  /**
   * Get a resource from the API
   * @param {string} rid Resource ID
   * @param {function} [collectionFactory] Collection factory function.
   * @return {Promise.<(ResModel|ResCollection)>} Promise of the resource.
   */
  get(e) {
    var t = this.cache[e];
    return t ? t.promise ? t.promise : (t.resetTimeout(), Promise.resolve(t.item)) : (t = new Ie(e, this._unsubscribe), this.cache[e] = t, t.setPromise(this._subscribe(t, !0).then(() => t.item)));
  }
  /**
   * Calls a method on a resource.
   * @param {string} rid Resource ID.
   * @param {string} method Method name
   * @param {*} params Method parameters
   * @returns {Promise.<object>} Promise of the call result.
   */
  call(e, t, r) {
    return this._call("call", e, t, r);
  }
  /**
   * Invokes an authentication method on a resource.
   *
   * RT Custom Code:
   * Update authenticate function to handle re-subscribe only if authenticated
   *
   * @param {string} rid Resource ID.
   * @param {string} method Method name
   * @param {*} params Method parameters
   * @returns {Promise.<object>} Promise of the authentication result.
   */
  authenticate(e, t, r) {
    return new Promise((s, u) => {
      this._call("auth", e, t, r).then((a) => {
        if (!a.token || a.token === "null") throw new Error("Authentication failed.");
        this._subscribeToAllStale(), s(a);
      }).catch((a) => u(a));
    });
  }
  /**
   * Creates a new resource by calling the 'new' method.  
   * Use call with 'new' as method parameter instead.
   * @param {*} rid Resource ID
   * @param {*} params Method parameters
   * @return {Promise.<(ResModel|ResCollection)>} Promise of the resource.
   * @deprecated since version 2.1.0. Use call with 'new' as method parameter instead.
   */
  create(e, t) {
    return this._send("new", e, null, t).then((r) => {
      this._cacheResources(r);
      var s = this.cache[r.rid];
      return s.addSubscribed(1), s.item;
    });
  }
  /**
   * Calls the set method to update model properties.
   * @param {string} modelId Model resource ID.
   * @param {object} props Properties. Set value to undefined to delete a property.
   * @returns {Promise.<object>} Promise of the call being completed.
   */
  setModel(e, t) {
    return t = Object.assign({}, t), Object.keys(t).forEach((r) => {
      t[r] === void 0 && (t[r] = fr);
    }), this._send("call", e, "set", t);
  }
  resourceOn(e, t, r) {
    var s = this.cache[e];
    if (!s)
      throw new Error("Resource " + e + " not found in cache");
    this.eventBus.on(s.item, t, r, this.namespace + ".resource." + e), s.addDirect();
  }
  resourceOff(e, t, r) {
    var s = this.cache[e];
    if (!s)
      throw new Error("Resource " + e + " not found in cache");
    this.eventBus.off(s.item, t, r, this.namespace + ".resource." + e, !0), s.removeDirect();
  }
  /**
   * Sends a JsonRpc call to the API
   * @param {string} action Action name
   * @param {string} rid Resource ID
   * @param {?string} method Optional method name
   * @param {?object} params Optional parameters
   * @returns {Promise.<object>} Promise to the response
   * @private
   */
  _send(e, t, r, s) {
    if (!t)
      throw new Error("Invalid resource ID");
    if (r === "")
      throw new Error("Invalid method");
    var u = e + "." + t + (r ? "." + r : "");
    return this.connected ? this._sendNow(u, s) : this.connect().catch((a) => {
      throw new fe(t, u, s).__init(a);
    }).then(() => this._sendNow(u, s));
  }
  _sendNow(e, t) {
    return new Promise((r, s) => {
      var u = {
        id: this.reqId++,
        method: e,
        params: t || void 0
      };
      this.requests[u.id] = {
        method: e,
        params: u.params,
        resolve: r,
        reject: s
      };
      var a = JSON.stringify(u);
      this.debug && console.debug("<== " + u.id + ":" + a), this.ws.send(a);
    });
  }
  /**
   * Receives a incoming json encoded data string and executes the appropriate functions/callbacks.
   * @param {string} json Json encoded data
   * @private
   */
  _receive(e) {
    var t = JSON.parse(e.trim());
    if (t.hasOwnProperty("id")) {
      this.debug && console.debug("==> " + t.id + ":" + e);
      var r = this.requests[t.id];
      if (!r)
        throw new Error("Server response without matching request");
      delete this.requests[t.id], t.hasOwnProperty("error") ? this._handleErrorResponse(r, t) : this._handleSuccessResponse(r, t);
    } else if (t.hasOwnProperty("event"))
      this.debug && console.debug("--> " + e), this._handleEvent(t);
    else
      throw new Error("Invalid message from server: " + e);
  }
  _call(e, t, r, s) {
    return this._send(e, t, r || "", s).then((u) => {
      if (this.protocol <= ce)
        return u;
      if (u.rid) {
        this._cacheResources(u);
        var a = this.cache[u.rid];
        return a.addSubscribed(1), a.item;
      }
      return u.payload;
    });
  }
  _handleErrorResponse(e, t) {
    var r = e.method, s = "", u = r.indexOf(".");
    if (u >= 0) {
      s = r.substr(u + 1);
      var a = r.substr(0, u);
      (a === "call" || a === "auth") && (u = s.lastIndexOf("."), u >= 0 && (s = s.substr(0, u)));
    }
    var i = new fe(s.trim(), r, e.params);
    i.__init(t.error);
    try {
      this._emit("error", i);
    } catch {
    }
    e.reject(i);
  }
  _handleSuccessResponse(e, t) {
    e.resolve(t.result);
  }
  _handleEvent(e) {
    var t = e.event.lastIndexOf(".");
    if (t < 0 || t === e.event.length - 1)
      throw new Error("Malformed event name: " + e.event);
    var r = e.event.substr(0, t), s = this.cache[r];
    if (!s)
      throw new Error("Resource not found in cache");
    var u = e.event.substr(t + 1), a = !1;
    switch (u) {
      case "change":
        a = this._handleChangeEvent(s, u, e.data, !1);
        break;
      case "add":
        a = this._handleAddEvent(s, u, e.data);
        break;
      case "remove":
        a = this._handleRemoveEvent(s, u, e.data);
        break;
      case "unsubscribe":
        a = this._handleUnsubscribeEvent(s);
        break;
    }
    a || this.eventBus.emit(s.item, this.namespace + ".resource." + r + "." + u, e.data);
  }
  _handleChangeEvent(e, t, r, s) {
    if (e.type !== H)
      return !1;
    this._cacheResources(r);
    var u = e.item, a, i = r.values;
    for (var o in i)
      i[o] = this._prepareValue(i[o]);
    var c = u.__update(i, s);
    if (!c)
      return !1;
    var l = {};
    for (var f in c)
      (a = X(c[f])) && (l[a] = (l[a] || 0) - 1), (a = X(i[f])) && (l[a] = (l[a] || 0) + 1);
    for (a in l) {
      var h = l[a], d = this.cache[a];
      d.addIndirect(h), h < 0 && this._tryDelete(d);
    }
    return this.eventBus.emit(e.item, this.namespace + ".resource." + e.rid + "." + t, c), !0;
  }
  _handleAddEvent(e, t, r) {
    if (e.type !== A)
      return !1;
    this._cacheResources(r);
    var s = this._prepareValue(r.value, !0), u = r.idx;
    return e.item.__add(s, u), this.eventBus.emit(e.item, this.namespace + ".resource." + e.rid + "." + t, {
      item: s,
      idx: u
    }), !0;
  }
  _handleRemoveEvent(e, t, r) {
    if (e.type !== A)
      return !1;
    var s = r.idx, u = e.item.__remove(s);
    this.eventBus.emit(e.item, this.namespace + ".resource." + e.rid + "." + t, {
      item: u,
      idx: s
    });
    var a = X(u);
    if (a) {
      var i = this.cache[a];
      if (!i)
        throw new Error("Removed model is not in cache");
      i.addIndirect(-1), this._tryDelete(i);
    }
    return !0;
  }
  _handleUnsubscribeEvent(e) {
    return e.addSubscribed(0), this._tryDelete(e), this.eventBus.emit(e.item, this.namespace + ".resource." + e.rid + ".unsubscribe", {
      item: e.item
    }), !0;
  }
  _setStale(e) {
    this._addStale(e), this.connected && setTimeout(() => this._subscribeToStale(e), pr);
  }
  _addStale(e) {
    this.stale || (this.stale = {}), this.stale[e] = !0;
  }
  _removeStale(e) {
    if (this.stale) {
      delete this.stale[e];
      for (var t in this.stale)
        return;
      this.stale = null;
    }
  }
  _subscribe(e, t) {
    var r = e.rid;
    return e.addSubscribed(1), this._removeStale(r), this._send("subscribe", r).then((s) => this._cacheResources(s)).catch((s) => {
      if (t)
        throw this._handleFailedSubscribe(e), s;
      this._handleUnsubscribeEvent(e);
    });
  }
  _subscribeToStale(e) {
    !this.connected || !this.stale || !this.stale[e] || this._subscribe(this.cache[e]);
  }
  _subscribeToAllStale() {
    if (this.stale)
      for (var e in this.stale)
        this._subscribeToStale(e);
  }
  /**
   * Handles the websocket onopen event
   * @param {object} e Open event object
   * @private
   */
  _handleOnopen(e) {
    this.debug && console.debug("ResClient open", e, this), this._sendNow("version", {
      protocol: this.supportedProtocol
    }).then((t) => {
      this.protocol = me(t.protocol) || ce;
    }).catch((t) => {
      if (t.code && t.code == "system.invalidRequest") {
        this.protocol = ce;
        return;
      }
      throw t;
    }).then(() => {
      if (this.onConnect) {
        this.connected = !0;
        var t = this.onConnect(this);
        return this.connected = !1, t;
      }
    }).then(() => {
      this.connected = !0, this._emit("connect", e), this._connectResolve();
    }).catch((t) => {
      this.ws && this.ws.close();
    });
  }
  /**
   * Handles the websocket onerror event
   * @param {object} e Error event object
   * @private
   */
  _handleOnerror(e) {
    this.debug && console.debug("ResClient error", e, this), this._connectReject({
      code: "system.connectionError",
      message: "Connection error",
      data: e
    });
  }
  /**
   * Handles the websocket onmessage event
   * @param {object} e Message event object
   * @private
   */
  _handleOnmessage(e) {
    this._receive(e.data);
  }
  /**
   * Handles the websocket onclose event
   * @param {object} e Close event object
   * @private
   */
  _handleOnclose(e) {
    this.debug && console.debug("ResClient close", e, this), this.connectPromise = null, this.ws = null;
    var t = this.connected;
    if (this.connected) {
      this.connected = !1;
      for (var r in this.cache) {
        var s = this.cache[r];
        s.subscribed && (s.addSubscribed(0), this._addStale(r), this._tryDelete(s));
      }
      this._emit("disconnect", e);
    }
    this.tryConnect && this._reconnect(t);
  }
  /**
   * Resolves the connection promise
   * @private
   */
  _connectResolve() {
    this.connectCallback && (this.connectCallback.resolve(), this.connectCallback = null);
  }
  /**
   * Rejects the connection promise
   * @param {*} e Error event
   * @private
   */
  _connectReject(e) {
    this.connectPromise = null, this.ws = null, this.connectCallback && (this.connectCallback.reject(e), this.connectCallback = null);
  }
  _emit(e, t) {
    this.eventBus.emit(this, e, t, this.namespace);
  }
  /**
   * Tries to delete the cached item.
   * It will delete if there are no direct listeners, indirect references, or any subscription.
   * @param {object} ci Cache item to delete
   * @private
   */
  _tryDelete(e) {
    var t = this._getRefState(e);
    for (var r in t) {
      var s = t[r];
      switch (s.st) {
        case ae:
          this._setStale(r);
          break;
        case x:
          this._deleteRef(s.ci);
          break;
      }
    }
  }
  /**
   * Reference State object
   * @typedef {object} RefState
   * @property {CacheItem} ci Cache item
   * @property {Number} rc Reference count from external references.
   * @property {Number} st State. Is either stateDelete, stateKeep, or stateStale.
   * @private
   */
  /**
   * Gets the reference state for a cacheItem and all its references
   * if the cacheItem was to be removed.
   * @param {CacheItem} ci Cache item
   * @return {Object.<string, RefState>} A key value object with key being the rid, and value being a RefState array.
   * @private
   */
  _getRefState(e) {
    var t = {};
    return e.subscribed || (t[e.rid] = {
      ci: e,
      rc: e.indirect,
      st: se
    }, this._traverse(e, this._seekRefs.bind(this, t), 0, !0), this._traverse(e, this._markDelete.bind(this, t), x)), t;
  }
  /**
   * Seeks for resources that no longer has any reference and may
   * be deleted.
   * Callback used with _traverse.
   * @param {*} refs References
   * @param {*} ci Cache item
   * @param {*} state State as returned from parent's traverse callback
   * @returns {*} State to pass to children. False means no traversing to children.
   * @private
   */
  _seekRefs(e, t, r) {
    if (t.subscribed)
      return !1;
    var s = t.rid, u = e[s];
    return u ? (u.rc--, !1) : (e[s] = {
      ci: t,
      rc: t.indirect - 1,
      st: se
    }, !0);
  }
  /**
   * Marks reference as stateDelete, stateKeep, or stateStale, depending on
   * the values returned from a _seekRefs traverse.
   * @param {*} refs References
   * @param {*} ci Cache item
   * @param {*} state State as returned from parent's traverse callback
   * @return {*} State to pass to children. False means no traversing to children.
   * @private
   */
  _markDelete(e, t, r) {
    if (t.subscribed)
      return !1;
    var s = t.rid, u = e[s];
    return u.st === oe ? !1 : r === x ? u.rc > 0 ? (u.st = oe, s) : u.st !== se ? !1 : u.ci.direct ? (u.st = ae, s) : (u.st = x, x) : s === r ? !1 : (u.st = oe, u.rc > 0 ? s : r);
  }
  _deleteRef(e) {
    var t = e.item, r;
    switch (e.type) {
      case A:
        for (var s of t)
          r = this._getRefItem(s), r && r.addIndirect(-1);
        break;
      case H:
        for (var u in t)
          t.hasOwnProperty(u) && (r = this._getRefItem(t[u]), r && r.addIndirect(-1));
        break;
    }
    delete this.cache[e.rid], this._removeStale(e.rid);
  }
  _getRefItem(e) {
    var t = X(e);
    if (!t)
      return null;
    var r = this.cache[t];
    return r || null;
  }
  _cacheResources(e) {
    if (!(!e || !(e.models || e.collections || e.errors))) {
      var t = {};
      ie.forEach((r) => t[r] = this._createItems(e[r + "s"], this.types[r])), ie.forEach((r) => this._initItems(e[r + "s"], this.types[r])), ie.forEach((r) => this._syncItems(t[r], this.types[r]));
    }
  }
  _createItems(e, t) {
    if (e) {
      var r;
      for (var s in e) {
        var u = this.cache[s];
        if (u ? this._removeStale(s) : u = this.cache[s] = new Ie(s, this._unsubscribe), u.item)
          u.type !== t.id ? console.error("Resource type inconsistency") : (r = r || {}, r[s] = e[s]), delete e[s];
        else {
          var a = t.getFactory(s);
          u.setItem(a(this, s), t.id);
        }
      }
      return r;
    }
  }
  _initItems(e, t) {
    if (e)
      for (var r in e) {
        var s = this.cache[r];
        s.item.__init(t.prepareData(e[r]));
      }
  }
  _syncItems(e, t) {
    if (e)
      for (var r in e) {
        var s = this.cache[r];
        t.synchronize(s, e[r]);
      }
  }
  _syncModel(e, t) {
    this._handleChangeEvent(e, "change", {
      values: t
    }, !0);
  }
  _syncCollection(e, t) {
    for (var r = e.item, s = r.length, u = new Array(s); s--; )
      u[s] = r.atIndex(s);
    var a = t.map((i) => this._prepareValue(i));
    this._patchDiff(u, a, (i, o, c, l) => {
    }, (i, o, c) => this._handleAddEvent(e, "add", {
      value: t[o],
      idx: c
    }), (i, o, c) => this._handleRemoveEvent(e, "remove", {
      idx: c
    }));
  }
  _patchDiff(e, t, r, s, u) {
    for (var a, i, o, c = 0, l, f, h = e.length, d = t.length; c < h && c < d && j(e[c], t[c]); )
      c++;
    if (!(c === h && c === d)) {
      for (; c < h && c < d && j(e[h - 1], t[d - 1]); )
        h--, d--;
      c > 0 || h < e.length ? (l = e.slice(c, h), h = l.length) : l = e, c > 0 || d < t.length ? (f = t.slice(c, d), d = f.length) : f = t;
      var _ = new Array(h + 1);
      for (i = 0; i <= h; i++)
        _[i] = a = new Array(d + 1), a[0] = 0;
      for (a = _[0], o = 1; o <= d; o++)
        a[o] = 0;
      for (i = 0; i < h; i++)
        for (o = 0; o < d; o++)
          _[i + 1][o + 1] = j(l[i], f[o]) ? _[i][o] + 1 : Math.max(_[i + 1][o], _[i][o + 1]);
      for (i = e.length - 1; i >= c + h; i--)
        r(e[i], i, i - h + d, i);
      var m = h + c;
      i = h, o = d;
      for (var b = 0, v = []; ; )
        if (h = i - 1, d = o - 1, i > 0 && o > 0 && j(l[h], f[d]))
          r(l[h], h + c, d + c, --m), i--, o--;
        else if (o > 0 && (i === 0 || _[i][d] >= _[h][o]))
          v.push([d, m, b]), o--;
        else if (i > 0 && (o === 0 || _[i][d] < _[h][o]))
          u(l[h], h + c, --m), b++, i--;
        else
          break;
      for (i = c - 1; i >= 0; i--)
        r(e[i], i, i, i);
      var w = v.length - 1;
      for (i = w; i >= 0; i--)
        [d, m, o] = v[i], s(f[d], d + c, m - b + o + w - i);
    }
  }
  _unsubscribe(e) {
    if (!e.subscribed) {
      this.stale && this.stale[e.rid] && this._tryDelete(e);
      return;
    }
    this._subscribeReferred(e);
    var t = e.subscribed;
    if (this.protocol < mr)
      for (; t--; )
        this._sendUnsubscribe(e, 1);
    else
      this._sendUnsubscribe(e, t);
  }
  _sendUnsubscribe(e, t) {
    this._send("unsubscribe", e.rid, null, t > 1 ? {
      count: t
    } : null).then(() => {
      e.addSubscribed(-t), this._tryDelete(e);
    }).catch(() => this._tryDelete(e));
  }
  _subscribeReferred(e) {
    var t = e.subscribed;
    e.subscribed = 0;
    var r = this._getRefState(e);
    e.subscribed = t;
    for (var s in r) {
      var u = r[s];
      u.st === ae && this._subscribe(u.ci);
    }
  }
  _handleFailedSubscribe(e) {
    e.addSubscribed(-1), this._tryDelete(e);
  }
  _reconnect(e) {
    if (e) {
      this.connect();
      return;
    }
    setTimeout(() => {
      this.tryConnect && this.connect();
    }, _r);
  }
  _resolvePath(e) {
    if (e.match(/^wss?:\/\//) || typeof document > "u" || !document.createElement)
      return e;
    var t = document.createElement("a");
    return t.href = e, t.href.replace(/^http/, "ws");
  }
  _traverse(e, t, r) {
    var s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
    if (!(!s && (r = t(e, r), r === !1))) {
      var u = e.item;
      switch (e.type) {
        case A:
          for (var a of u) {
            var i = this._getRefItem(a);
            i && this._traverse(i, t, r);
          }
          break;
        case H:
          for (var o in u)
            if (u.hasOwnProperty(o)) {
              var c = this._getRefItem(u[o]);
              c && this._traverse(c, t, r);
            }
          break;
      }
    }
  }
  _prepareValue(e, t) {
    if (e !== null && typeof e == "object")
      if (e.rid)
        if (e.soft)
          e = new ve(this, e.rid);
        else {
          var r = this.cache[e.rid];
          t && r.addIndirect(), e = r.item;
        }
      else if (e.hasOwnProperty("data"))
        e = e.data;
      else if (e.action === "delete")
        e = void 0;
      else
        throw new Error("Invalid value: " + JSON.stringify(e));
    return e;
  }
}
const U = class U {
  constructor() {
    Q(this, "_client");
    Q(this, "_authenticated", B(!1));
    Q(this, "_error", B(null));
  }
  get client() {
    return this._client;
  }
  get authenticated() {
    return this._authenticated.value;
  }
  get error() {
    return this._error.value;
  }
  static getInstance() {
    return this.instance || (U.instance = new U()), U.instance;
  }
  async connectAndAuthorize(e, t, r) {
    this._client = new gr(`${e}?${t}=${r}`).registerModelType(
      ">",
      (s, u) => Ce(new xe(s, u))
    ).registerCollectionType(
      ">",
      (s, u) => Ce(new Qe(s, u))
    ), this._client.on("connect", (s) => {
      this._authenticated.value = !0, this._error.value = null;
    }), this._client.on("disconnect", (s) => {
      this._authenticated.value = !1;
    }), this._client.on(null, (s) => {
      ["open", "close"].includes(s.type) || (this._error.value = s.message);
    });
    try {
      const s = await this._client.connect();
      return new Promise((u, a) => {
        u(s);
      });
    } catch (s) {
      return this._client.disconnect(), new Promise((u, a) => {
        a(s);
      });
    }
  }
  logout() {
    this._authenticated.value = !1;
  }
};
Q(U, "instance");
let Pe = U;
const Y = "8.48.0", N = globalThis;
function ge(n, e, t) {
  const r = t || N, s = r.__SENTRY__ = r.__SENTRY__ || {}, u = s[Y] = s[Y] || {};
  return u[n] || (u[n] = e());
}
const He = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, br = "Sentry Logger ", Me = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], ke = {};
function wr(n) {
  if (!("console" in N))
    return n();
  const e = N.console, t = {}, r = Object.keys(ke);
  r.forEach((s) => {
    const u = ke[s];
    t[s] = e[s], e[s] = u;
  });
  try {
    return n();
  } finally {
    r.forEach((s) => {
      e[s] = t[s];
    });
  }
}
function yr() {
  let n = !1;
  const e = {
    enable: () => {
      n = !0;
    },
    disable: () => {
      n = !1;
    },
    isEnabled: () => n
  };
  return He ? Me.forEach((t) => {
    e[t] = (...r) => {
      n && wr(() => {
        N.console[t](`${br}[${t}]:`, ...r);
      });
    };
  }) : Me.forEach((t) => {
    e[t] = () => {
    };
  }), e;
}
const Z = ge("logger", yr);
function be() {
  return we(N), N;
}
function we(n) {
  const e = n.__SENTRY__ = n.__SENTRY__ || {};
  return e.version = e.version || Y, e[Y] = e[Y] || {};
}
const Sr = Object.prototype.toString;
function Er(n, e) {
  return Sr.call(n) === `[object ${e}]`;
}
function Cr(n) {
  return Er(n, "Object");
}
function Rr(n) {
  return !!(n && n.then && typeof n.then == "function");
}
function Ir(n, e, t) {
  try {
    Object.defineProperty(n, e, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: t,
      writable: !0,
      configurable: !0
    });
  } catch {
    He && Z.log(`Failed to add non-enumerable property "${e}" to object`, n);
  }
}
const Ve = 1e3;
function Ye() {
  return Date.now() / Ve;
}
function Nr() {
  const { performance: n } = N;
  if (!n || !n.now)
    return Ye;
  const e = Date.now() - n.now(), t = n.timeOrigin == null ? e : n.timeOrigin;
  return () => (t + n.now()) / Ve;
}
const Pr = Nr();
(() => {
  const { performance: n } = N;
  if (!n || !n.now)
    return;
  const e = 3600 * 1e3, t = n.now(), r = Date.now(), s = n.timeOrigin ? Math.abs(n.timeOrigin + t - r) : e, u = s < e, a = n.timing && n.timing.navigationStart, o = typeof a == "number" ? Math.abs(a + t - r) : e, c = o < e;
  return u || c ? s <= o ? n.timeOrigin : a : r;
})();
function L() {
  const n = N, e = n.crypto || n.msCrypto;
  let t = () => Math.random() * 16;
  try {
    if (e && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e && e.getRandomValues && (t = () => {
      const r = new Uint8Array(1);
      return e.getRandomValues(r), r[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (r) => (
      // eslint-disable-next-line no-bitwise
      (r ^ (t() & 15) >> r / 4).toString(16)
    )
  );
}
function Mr(n, e = {}) {
  if (e.user && (!n.ipAddress && e.user.ip_address && (n.ipAddress = e.user.ip_address), !n.did && !e.did && (n.did = e.user.id || e.user.email || e.user.username)), n.timestamp = e.timestamp || Pr(), e.abnormal_mechanism && (n.abnormal_mechanism = e.abnormal_mechanism), e.ignoreDuration && (n.ignoreDuration = e.ignoreDuration), e.sid && (n.sid = e.sid.length === 32 ? e.sid : L()), e.init !== void 0 && (n.init = e.init), !n.did && e.did && (n.did = `${e.did}`), typeof e.started == "number" && (n.started = e.started), n.ignoreDuration)
    n.duration = void 0;
  else if (typeof e.duration == "number")
    n.duration = e.duration;
  else {
    const t = n.timestamp - n.started;
    n.duration = t >= 0 ? t : 0;
  }
  e.release && (n.release = e.release), e.environment && (n.environment = e.environment), !n.ipAddress && e.ipAddress && (n.ipAddress = e.ipAddress), !n.userAgent && e.userAgent && (n.userAgent = e.userAgent), typeof e.errors == "number" && (n.errors = e.errors), e.status && (n.status = e.status);
}
function Oe() {
  return L();
}
function Ae() {
  return L().substring(16);
}
function We(n, e, t = 2) {
  if (!e || typeof e != "object" || t <= 0)
    return e;
  if (n && e && Object.keys(e).length === 0)
    return n;
  const r = { ...n };
  for (const s in e)
    Object.prototype.hasOwnProperty.call(e, s) && (r[s] = We(r[s], e[s], t - 1));
  return r;
}
const de = "_sentrySpan";
function Te(n, e) {
  e ? Ir(n, de, e) : delete n[de];
}
function De(n) {
  return n[de];
}
const kr = 100;
class ye {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  // eslint-disable-next-line deprecation/deprecation
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = {
      traceId: Oe(),
      spanId: Ae()
    };
  }
  /**
   * @inheritDoc
   */
  clone() {
    const e = new ye();
    return e._breadcrumbs = [...this._breadcrumbs], e._tags = { ...this._tags }, e._extra = { ...this._extra }, e._contexts = { ...this._contexts }, this._contexts.flags && (e._contexts.flags = {
      values: [...this._contexts.flags.values]
    }), e._user = this._user, e._level = this._level, e._session = this._session, e._transactionName = this._transactionName, e._fingerprint = this._fingerprint, e._eventProcessors = [...this._eventProcessors], e._requestSession = this._requestSession, e._attachments = [...this._attachments], e._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, e._propagationContext = { ...this._propagationContext }, e._client = this._client, e._lastEventId = this._lastEventId, Te(e, De(this)), e;
  }
  /**
   * @inheritDoc
   */
  setClient(e) {
    this._client = e;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(e) {
    this._lastEventId = e;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(e) {
    this._scopeListeners.push(e);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(e) {
    return this._eventProcessors.push(e), this;
  }
  /**
   * @inheritDoc
   */
  setUser(e) {
    return this._user = e || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && Mr(this._session, { user: e }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  setRequestSession(e) {
    return this._requestSession = e, this;
  }
  /**
   * @inheritDoc
   */
  setTags(e) {
    return this._tags = {
      ...this._tags,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(e, t) {
    return this._tags = { ...this._tags, [e]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(e) {
    return this._extra = {
      ...this._extra,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(e, t) {
    return this._extra = { ...this._extra, [e]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(e) {
    return this._fingerprint = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(e) {
    return this._level = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(e) {
    return this._transactionName = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(e, t) {
    return t === null ? delete this._contexts[e] : this._contexts[e] = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(e) {
    return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(e) {
    if (!e)
      return this;
    const t = typeof e == "function" ? e(this) : e, [r, s] = t instanceof z ? (
      // eslint-disable-next-line deprecation/deprecation
      [t.getScopeData(), t.getRequestSession()]
    ) : Cr(t) ? [e, e.requestSession] : [], { tags: u, extra: a, user: i, contexts: o, level: c, fingerprint: l = [], propagationContext: f } = r || {};
    return this._tags = { ...this._tags, ...u }, this._extra = { ...this._extra, ...a }, this._contexts = { ...this._contexts, ...o }, i && Object.keys(i).length && (this._user = i), c && (this._level = c), l.length && (this._fingerprint = l), f && (this._propagationContext = f), s && (this._requestSession = s), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Te(this, void 0), this._attachments = [], this.setPropagationContext({ traceId: Oe() }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(e, t) {
    const r = typeof t == "number" ? t : kr;
    if (r <= 0)
      return this;
    const s = {
      timestamp: Ye(),
      ...e
    }, u = this._breadcrumbs;
    return u.push(s), this._breadcrumbs = u.length > r ? u.slice(-r) : u, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(e) {
    return this._attachments.push(e), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: De(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(e) {
    return this._sdkProcessingMetadata = We(this._sdkProcessingMetadata, e, 2), this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(e) {
    return this._propagationContext = {
      // eslint-disable-next-line deprecation/deprecation
      spanId: Ae(),
      ...e
    }, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(e, t) {
    const r = t && t.event_id ? t.event_id : L();
    if (!this._client)
      return Z.warn("No client configured on scope - will not capture exception!"), r;
    const s = new Error("Sentry syntheticException");
    return this._client.captureException(
      e,
      {
        originalException: e,
        syntheticException: s,
        ...t,
        event_id: r
      },
      this
    ), r;
  }
  /**
   * @inheritDoc
   */
  captureMessage(e, t, r) {
    const s = r && r.event_id ? r.event_id : L();
    if (!this._client)
      return Z.warn("No client configured on scope - will not capture message!"), s;
    const u = new Error(e);
    return this._client.captureMessage(
      e,
      t,
      {
        originalException: e,
        syntheticException: u,
        ...r,
        event_id: s
      },
      this
    ), s;
  }
  /**
   * @inheritDoc
   */
  captureEvent(e, t) {
    const r = t && t.event_id ? t.event_id : L();
    return this._client ? (this._client.captureEvent(e, { ...t, event_id: r }, this), r) : (Z.warn("No client configured on scope - will not capture event!"), r);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
      e(this);
    }), this._notifyingListeners = !1);
  }
}
const z = ye;
function Or() {
  return ge("defaultCurrentScope", () => new z());
}
function Ar() {
  return ge("defaultIsolationScope", () => new z());
}
class Tr {
  constructor(e, t) {
    let r;
    e ? r = e : r = new z();
    let s;
    t ? s = t : s = new z(), this._stack = [{ scope: r }], this._isolationScope = s;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(e) {
    const t = this._pushScope();
    let r;
    try {
      r = e(t);
    } catch (s) {
      throw this._popScope(), s;
    }
    return Rr(r) ? r.then(
      (s) => (this._popScope(), s),
      (s) => {
        throw this._popScope(), s;
      }
    ) : (this._popScope(), r);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const e = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: e
    }), e;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function $() {
  const n = be(), e = we(n);
  return e.stack = e.stack || new Tr(Or(), Ar());
}
function Dr(n) {
  return $().withScope(n);
}
function Ur(n, e) {
  const t = $();
  return t.withScope(() => (t.getStackTop().scope = n, e(n)));
}
function Ue(n) {
  return $().withScope(() => n($().getIsolationScope()));
}
function Lr() {
  return {
    withIsolationScope: Ue,
    withScope: Dr,
    withSetScope: Ur,
    withSetIsolationScope: (n, e) => Ue(e),
    getCurrentScope: () => $().getScope(),
    getIsolationScope: () => $().getIsolationScope()
  };
}
function Ge(n) {
  const e = we(n);
  return e.acs ? e.acs : Lr();
}
function Br() {
  const n = be();
  return Ge(n).getCurrentScope();
}
function Fr(...n) {
  const e = be(), t = Ge(e);
  if (n.length === 2) {
    const [r, s] = n;
    return r ? t.withSetScope(r, s) : t.withScope(s);
  }
  return t.withScope(n[0]);
}
function zr(n) {
  if (n)
    return $r(n) ? { captureContext: n } : Qr(n) ? {
      captureContext: n
    } : n;
}
function $r(n) {
  return n instanceof z || typeof n == "function";
}
const qr = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function Qr(n) {
  return Object.keys(n).some((e) => qr.includes(e));
}
function xr(n, e) {
  return Br().captureException(n, zr(e));
}
function cn(n, e, t, r) {
  Fr(function(s) {
    t && t.forEach((u, a) => {
      s.setTag(a, u);
    }), r && s.setUser({ id: r }), s.addBreadcrumb(e), xr(new Error(n));
  });
}
export {
  O as AssetType,
  Zr as BaseAppContainer,
  en as FullSizeLayout,
  Pe as JanaClient,
  Xr as ModalComponent,
  Kr as QrCodeModal,
  Wr as SidebarButton,
  Yr as VersionTag,
  tn as VerticalOverlay,
  Gr as WidgetHeader,
  Jr as WidgetWrapper,
  an as findGroupByClickupStatus,
  sn as mimeTypeReviewPossible,
  nn as mimeTypeToAssetType,
  cn as sendSentryErrorMsg,
  on as shouldUseOriginalFile,
  rn as useUserStore
};
